// @flow
import React from 'react';
import {SVGIcon} from '@homeaway/react-svg';

const IconAlarmClockMarkUp = `
    <svg version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" xml:space="preserve" width="32" height="32"
    >
        <g class="nc-icon-wrapper" fill="#444444">
            <polyline data-color="color-2" fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" points=" 16,12 16,18 22,18 " stroke-linejoin="miter"></polyline>
            <line data-cap="butt" fill="none" stroke="#444444" stroke-width="2" stroke-miterlimit="10" x1="2" y1="31" x2="7" y2="26" stroke-linejoin="miter" stroke-linecap="butt"></line>
            <line data-cap="butt" fill="none" stroke="#444444" stroke-width="2" stroke-miterlimit="10" x1="30" y1="31" x2="25" y2="26" stroke-linejoin="miter" stroke-linecap="butt"></line>
            <circle fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" cx="16" cy="18" r="12" stroke-linejoin="miter"></circle>
            <path data-color="color-2" fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M12.4,2.8 C11.2,1.7,9.6,1,7.8,1C4.1,1,1,4.1,1,7.8c0,1.1,0.3,2.1,0.7,3C3.9,6.8,7.8,3.8,12.4,2.8z" stroke-linejoin="miter"></path>
            <path data-color="color-2" fill="none" stroke="#444444" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M19.6,2.8 C20.8,1.7,22.4,1,24.2,1C27.9,1,31,4.1,31,7.8c0,1.1-0.3,2.1-0.7,3C28.1,6.8,24.2,3.8,19.6,2.8z" stroke-linejoin="miter"></path>
        </g>
    </svg>`;

const IconAlarmClock = () => <SVGIcon markup={IconAlarmClockMarkUp} />;

export default IconAlarmClock;
